import { MillenniumDateTime } from "./MillenniumDateTime.js";
import { SimpleDateFormat } from "./SimpleDateFormat.js";
const SECONDS_PER_DAY = 86400;
/**
 * Four variants:
 * * One argument - either a time number or a MillenniumDateTime
 * * Three arguments - hour, minute and second
 * * Four argumenst - day, hour, minute and second
 */
export class MillenniumTime {
    timeNumber;
    constructor(param1, param2, param3, param4) {
        if (arguments.length === 1) {
            const time = param1;
            // const MillenniumDateTime = require("./MillenniumDateTime");
            if (time instanceof MillenniumDateTime) {
                this.timeNumber = time.getMts() % SECONDS_PER_DAY;
            }
            else {
                this.timeNumber = time;
            }
        }
        else if (arguments.length === 3) {
            this.timeNumber = param1 * 3600 + param2 * 60 + param3;
        }
        else if (arguments.length === 4) {
            this.timeNumber =
                param1 * SECONDS_PER_DAY + param2 * 3600 + param3 * 60 + param4;
        }
        else {
            this.timeNumber = 0;
        }
    }
    static now() {
        const now = new Date();
        return new MillenniumTime(now.getHours(), now.getMinutes(), now.getSeconds());
    }
    getTimeNumber() {
        return this.timeNumber;
    }
    getHours() {
        return Math.floor(this.timeNumber / 3600);
    }
    getMinutes() {
        return Math.floor((this.timeNumber % 3600) / 60);
    }
    getSeconds() {
        return this.timeNumber % 60;
    }
    addSeconds(seconds) {
        return new MillenniumTime(this.getTimeNumber() + seconds);
    }
    format(format) {
        format = format || "HHmmss";
        return SimpleDateFormat.format(this, format); // TODO: We have a bug here, the types don't add up. remove any.
    }
    toString() {
        return this.format();
    }
    isBetween(start, end, inclusive) {
        inclusive = inclusive === undefined ? true : inclusive;
        if (inclusive) {
            return this.timeNumber >= start.timeNumber && this.timeNumber <= end.timeNumber;
        }
        return this.timeNumber > start.timeNumber && this.timeNumber < end.timeNumber;
    }
    equals(obj) {
        if (this === obj) {
            return true;
        }
        if (obj === null || obj === undefined) {
            return false;
        }
        if (!(obj instanceof MillenniumTime)) {
            return false;
        }
        return this.timeNumber === obj.getTimeNumber();
    }
}
